import type { DriverPenaltySeverity, DriverPenaltyType } from '@/backend/market'
import type { DriverEntity } from '@/features/driver/domain/entities/DriverEntity'

export class PostDriverPenaltyEntity {
  driver?: DriverEntity | null
  type?: DriverPenaltyType
  severity?: DriverPenaltySeverity
  reason?: string | null
  detectedAt?: Date | string | null
  effectiveFrom?: Date | string | null
  effectiveTo?: Date | string | null
}
